/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { openDB } from "idb";
import SetupModal from "./SetupModal";
import KotFieldCustomizationForm from "./KotFieldCustomizationForm";
import KotPrinterSetupFormGroup from "./KotPrinterSetupFormGroup";
import ItemGroupingForm from "./ItemGroupingForm";
import styles from "../css/SetupForm.module.css";
import axios from "axios";
import Context from "../context/context";

export default function KotSetupForm({ onSave }) {

  const [kotSetup, setKotSetup] = useState({});
  const [customizationModalOpen, setCustomizationModalOpen] = useState(false);
  const [groupingModalOpen, setGroupingModalOpen] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [pageConfigurationSetup, setPageConfigrationSetup] = useState(0);

  const context = useContext(Context);
  const { updateUnSync } = context;

  useEffect(() => {
    const getPrinterData = () => {
      axios({ method: "get", url: "http://127.0.0.1:7878/printers" })
        .then((res) => {
          setPrinters(res.data);
        })
        .catch((err) => console.log(err));
    };
    getPrinterData();
  }, []);

  useEffect(() => {
    const asyncfunc = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const outletStore = db.transaction("outlet", "readonly").objectStore("outlet");
      const currentOutlet = (await outletStore.getAll())[0];
      const dbKotSetup = currentOutlet.kot_setup;

      setKotSetup({
        ...dbKotSetup,
        kot_type: currentOutlet.kot_type,
      });
    }
    asyncfunc()
  }, [pageConfigurationSetup]);

  const handleTypeChange = (event) => {
    setKotSetup({ ...kotSetup, kot_type: event.target.value });
  };

  const setPrinterSetup = (updated) =>
    setKotSetup({
      ...kotSetup,
      printer_setup: updated,
    });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outletStore = db
      .transaction("outlet", "readwrite")
      .objectStore("outlet");

    const outlet = (await outletStore.getAll())[0];
    const updatedValue = {
      ...outlet,
      kot_setup: Object.keys(kotSetup)
        .filter((key) => key !== "kot_type")
        .reduce((obj, key) => {
          obj[key] = kotSetup[key];
          return obj;
        }, {}),
      kot_type: kotSetup.kot_type
    };

    sessionStorage.setItem("kot_type", +updatedValue.kot_type);
    // console.log(updatedValue);
    await outletStore.put(updatedValue);
    await handleKOTUnsyncedFile(updatedValue);
    await handleMenuAddUnsyncedFiles(kotSetup.kot_type);
    onSave();
  };

  const handleMenuAddUnsyncedFiles = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      kot_type: data,
      RECON_TIME: new Date().getTime().toString(),
      IDENTIFIER: "kot_type",
    };
    await tx.put(ndata);
    await handleMenuReconciliation(ndata);
    updateUnSync();
  };

  // Adding/Editing menu to reconciliation collection in IndexedDB
  const handleMenuReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const othersJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "others"
    );
    if (othersJsonExists) {
      const kot = othersJsonExists?.details?.filter(
        (entry) => entry.type !== "kot_type"
      );
      const editData = {
        ...othersJsonExists,
        details: [
          ...kot,
          {
            type: "kot_type",
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "others",
        details: [
          {
            type: "kot_type",
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  const handleKOTUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      IDENTIFIER: "kot_setup",
      RECON_TIME: Date.now(),
      kot_setup: { ...data.kot_setup },
    };
    await tx.put(ndata);
    handleKOTReconciliation(ndata);
    updateUnSync();
  };

  return (
    <>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.heading}>
          <h1>KOT Setup</h1>
        </div>

        <div className={styles.formContainer}>
          <div
            style={{
              display: "flex",
              gap: "15px",
              justifyContent: "flex-end",
            }}>
            <button
              type='button'
              className={styles.fieldCustomizationButton}
              style={{ position: "static" }}
              onClick={() => setCustomizationModalOpen(true)}>
              Field customization
            </button>

            <button
              type='button'
              className={styles.fieldCustomizationButton}
              onClick={() => setGroupingModalOpen(true)}>
              Item grouping
            </button>
          </div>

          <div className={`${styles.formGroup} ${styles.kotGeneral}`}>
            <h2>General</h2>

            <label className={styles.selectLabel}>
              KOT Type
              <select
                name='kot_type'
                className={styles.select}
                value={kotSetup?.kot_type}
                onChange={handleTypeChange}>
                <option value={1}>KDS (Digital)</option>
                <option value={2}>Printed KOT</option>
              </select>
            </label>
          </div>

          <KotPrinterSetupFormGroup
            printerSetup={kotSetup?.printer_setup}
            setPrinterSetup={setPrinterSetup}
            printers={printers}
            setPageConfigrationSetup={setPageConfigrationSetup}
          />

          <button type='submit' className={styles.submit}>
            Save changes
          </button>
        </div>
        {customizationModalOpen && (
          <SetupModal onClose={() => setCustomizationModalOpen(false)}>
            <KotFieldCustomizationForm
              kotFieldCustomizations={kotSetup?.kot_field_customization}
              setCustomizationModalOpen={setCustomizationModalOpen}
              setKotFieldCustomizations={(newKotFieldCustomization) =>
                setKotSetup({
                  ...kotSetup,
                  kot_field_customization: newKotFieldCustomization,
                })
              }
            />
          </SetupModal>
        )}

        {groupingModalOpen && (
          <SetupModal onClose={() => setGroupingModalOpen(false)}>
            <ItemGroupingForm onSave={() => setGroupingModalOpen(false)} />
          </SetupModal>
        )}
      </form>
      {pageConfigurationSetup ? (
        <SetupModal onClose={() => setPageConfigrationSetup(0)}>
          <PageConfigurationForm
            setPageConfigrationSetup={setPageConfigrationSetup}
            pageConfigurationSetup={pageConfigurationSetup}
            setKotSetup={setKotSetup}
            kotSetup={kotSetup}
          />
        </SetupModal>
      ) : (
        ""
      )}
    </>
  );
}

// Adding/Editing kot to reconciliation collection in IndexedDB
const handleKOTReconciliation = async (data) => {
  const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
  const tx = await db
    .transaction("reconciliation", "readwrite")
    .objectStore("reconciliation");
  const allReconRecords = await tx.getAll();

  const othersJsonExists = allReconRecords.find(
    (curr) => curr.IDENTIFIER === "others"
  );
  if (othersJsonExists) {
    const kot = othersJsonExists?.details?.filter(
      (entry) => entry.type !== "kot_setup"
    );
    const editData = {
      ...othersJsonExists,
      details: [
        ...kot,
        {
          type: "kot_setup",
          RECON_TIME: data.RECON_TIME,
        },
      ],
    };
    await tx.put(editData);
  } else {
    const newdata = {
      IDENTIFIER: "others",
      details: [
        {
          type: "kot_setup",
          RECON_TIME: data.RECON_TIME,
        },
      ],
    };
    await tx.add(newdata);
  }
};

const PageConfigurationForm = ({
  setPageConfigrationSetup,
  pageConfigurationSetup,
  setKotSetup,
  kotSetup,
}) => {
  const [pageConfiguration, setPageConfiguration] = useState({
    left_margin: "0",
    right_margin: "0",
    upper_margin: "0",
    page_height: "0",
    page_width: "0",
    page_type: "",
    orientation: "",
  });
  const context = useContext(Context);
  const { updateUnSync } = context;
  console.log(kotSetup.printer_setup[pageConfigurationSetup - 1]);
  useEffect(() => {
    const getData = () => {
      setPageConfiguration({
        ...pageConfiguration,
        ...kotSetup.printer_setup[pageConfigurationSetup - 1]
          ?.page_configuration[0],
        page_type:
          kotSetup.printer_setup[pageConfigurationSetup - 1]
            ?.page_configuration[0]?.page_type === "F"
            ? "F"
            : "V",
        orientation:
          kotSetup.printer_setup[pageConfigurationSetup - 1]
            ?.page_configuration[0]?.orientation === "P"
            ? "P"
            : "L",
      });
    };
    getData();
  }, []);

  // console.log("pageconfigration",pageConfiguration)

  const formSubmits = async (e) => {
    e.preventDefault();

    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outletStore = db
      .transaction("outlet", "readwrite")
      .objectStore("outlet");
    let outlet = (await outletStore.getAll())[0];
    outlet.kot_setup.printer_setup[
      pageConfigurationSetup - 1
    ].page_configuration = [
        {
          ...outlet.kot_setup.printer_setup[pageConfigurationSetup - 1]
            .page_configuration[0],
          ...pageConfiguration,
        },
      ];

    await outletStore.put(outlet);

    handleKOTUnsyncedFile(outlet);
    setPageConfigrationSetup(0);
  };
  const handleKOTUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      IDENTIFIER: "kot_setup",
      RECON_TIME: Date.now(),
      kot_setup: { ...data.kot_setup },
    };
    await tx.put(ndata);
    handleKOTReconciliation(ndata);
    updateUnSync();
  };

  return (
    <form className={styles.form} onSubmit={formSubmits}>
      <div className={styles.heading}>
        <h1>Page Configuration</h1>
      </div>

      <div className={styles.formContainer}>
        <div className={styles.formGroup}>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Left Margin
              <input
                type='number'
                name='left_margin'
                className={styles.numberInput}
                onInput={(e) => (e.target.value = e.target.value.slice(0, 4))}
                value={pageConfiguration?.left_margin}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    left_margin: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>

            <label className={styles.selectLabel}>
              Right Margin
              <input
                name='right_margin'
                className={styles.numberInput}
                type='text'
                maxLength='4'
                value={pageConfiguration?.right_margin}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    right_margin: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>
          </div>

          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Bottom Margin
              <input
                type='text'
                name='bottom_margin'
                className={styles.numberInput}
                maxLength='4'
                value={pageConfiguration?.bottom_margin}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    bottom_margin: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Page Height
              <input
                type='text'
                name='page_height'
                className={styles.numberInput}
                maxLength='4'
                style={{ "-moz-appearance": "textfield", width: "100%" }}
                disabled={pageConfiguration?.page_type !== "F"}
                value={pageConfiguration?.page_height}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    page_height: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>

            <label className={styles.selectLabel}>
              Page Width
              <input
                name='page_width'
                className={styles.numberInput}
                type='text'
                maxLength='4'
                value={pageConfiguration?.page_width}
                onChange={(e) =>
                  setPageConfiguration({
                    ...pageConfiguration,
                    page_width: e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1"),
                  })
                }
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Page Type
              <select
                name='page_type'
                className={styles.select}
                value={pageConfiguration?.page_type}
                onChange={(e) => {
                  console.log(e.target.value);
                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value,
                  });
                }}>
                <option value='V'>Flexible Height</option>
                <option value='F'>Fixed Height</option>
              </select>
            </label>
            <label className={styles.selectLabel}>
              Page Orientation
              <select
                name='orientation'
                className={styles.select}
                value={pageConfiguration?.orientation}
                onChange={(e) => {
                  console.log(e.target.value);

                  setPageConfiguration({
                    ...pageConfiguration,
                    [e.target.name]: e.target.value,
                  });
                }}>
                <option value='P'>Portrait</option>
                <option value='L'>Landscape</option>
              </select>
            </label>
          </div>
          <button className={styles.submit} type='submit'>
            Save changes
          </button>
        </div>
      </div>
    </form>
  );
};